// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { AssetFragmentDoc } from '../../../fragments/asset.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from './stoneShapeTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../../gems/fragments/StoneColorTranslation.fragment.generated';
import { StoneClarityFragmentDoc } from '../../gems/fragments/stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from '../../gems/fragments/ClarityTranslation.fragment.generated';
import { NonSkuLabGrownStoneImageFragmentDoc } from '../../../../../domain/stone/useStoneImage.generated';
import { MonolithImageSizeFragmentDoc } from '../../../../../components/useImageProps.generated';
export const NonSkuLabGrownFragmentDoc = `
    fragment nonSkuLabGrown on NonSkuLabGrown {
  __typename
  id
  salePrice(currency: $currency, country: $country) {
    ...money
  }
  shape {
    ...stoneShape
  }
  caratWeight
  color {
    ...stoneColor
  }
  clarity {
    ...stoneClarity
  }
  ...nonSkuLabGrownStoneImage
}
    `;